
import { useRef, useState } from "react";
import CanvasDraw from "react-canvas-draw";
import { PDFDownloadLink, Page, View, Document, Text, Image, Font, StyleSheet, PDFViewer, PDFRenderer } from "@react-pdf/renderer";

export default function ContractDoc({user, parent, signing, acc, date}) {

    Font.register({
        family: "Roboto",
        fonts: [
          { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
          { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
          { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
          { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
        ],
      })
      
    
      const styles = StyleSheet.create({
        body: {
          paddingTop: 25,
          paddingBottom: 65,
          paddingHorizontal: 35,
          width: "50%"
        },
        title: {
          fontSize: 24,
          textAlign: 'center',
          fontFamily: 'Roboto',
          fontWeight: 600,
          marginBottom: 20
        },
        title2: {
            fontSize: 20,
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: 500
          },
        author: {
          fontSize: 12,
          textAlign: 'center',
          marginTop: 5
        },        author: {
          fontSize: 12,
          textAlign: 'center',
          marginTop: 5
        },
        date: {
            fontSize: 16,
            textAlign: 'right',
            marginBottom: 30,
            marginTop: 10,
            fontWeight: 500,
            fontFamily: 'Roboto',
          },
          name: {
            fontSize: 16,
            textAlign: 'left',
            marginBottom: 30,
            marginTop: 10,
            fontWeight: 500,
            fontFamily: 'Roboto',
          },
        subtitle: {
          fontSize: 9,
          textAlign: 'center',
          fontFamily: 'Roboto'
        },
        subtitle2: {
            fontSize: 9,
            textAlign: 'center',
            fontFamily: 'Roboto',
            marginBottom: 30
          },
        text: {
          margin: 7,
          fontSize: 12,
          textAlign: 'justify',
          fontFamily: 'Roboto'
        },
        textH: {
            margin: 3,
            fontSize: 12,
            textAlign: 'justify',
            fontFamily: 'Roboto',
            width: "80%"
          },
        textB: {
            margin: 7,
            fontSize: 12,
            textAlign: 'justify',
            fontFamily: 'Roboto',   
            fontWeight: 500
          },
        signs: {
            margin: 12,
            fontSize: 12,
            fontFamily: 'Roboto',
            fontWeight: 500
          },
        image: {
          marginVertical: 15,
          marginHorizontal: 10,
          width: 55,
          height: 55,
          alignSelf: "center"
        },
        imageTest: {
            position: "absolute",
            left: "0px",
            right: "0px",
            width: "100vw",
            height: "100vh",
            marginHorizontal: 'auto'
          },
        imageSign: {
            width: 85,
            height: 85,
            alignSelf: "center"
          },
          imageSignMini: {
            width: 60,
            height: 60,
            alignSelf: "center"
          },
        header: {
          fontSize: 12,
          marginBottom: 20,
          textAlign: 'center',
          color: 'grey',
        },
        pageNumber: {
          position: 'absolute',
          fontSize: 12,
          bottom: 30,
          left: 0,
          right: 0,
          textAlign: 'center',
          color: 'grey',
        },
      });

return (
    <>
          <Document>
            <Page style={styles.body}>
                  {user?.docs?.contract?.type === "obligation" ?
                  <Image
                    style={styles.imageTest}
                    src={process.env.PUBLIC_URL + "/UmowaTurniejowka_1.png"}
                    fixed
                  />
                  :
                  <Image
                    style={styles.imageTest}
                    src={process.env.PUBLIC_URL + "/Umowa2026_1.png"}
                    fixed
                  />
                  }

                <Text style={{top: "193px", left: "113px", fontSize: "10px", fontFamily: 'Roboto'}}>{date}</Text>
                <Text style={{top: "240px", left: "143px", fontSize: "10px", fontFamily: 'Roboto'}}>{parent?.displayName}</Text>
                <Text style={{top: "244px", left: "100px", fontSize: "10px", fontFamily: 'Roboto'}}>ul. {parent?.address?.street + "/" + parent?.address?.local} {parent?.address?.city}</Text>
                <Text style={{top: "248px", left: "70px", fontSize: "10px", fontFamily: 'Roboto'}}>{parent?.phone}</Text>
                <Text style={{top: "234px", left: "216px", fontSize: "10px", fontFamily: 'Roboto'}}>{acc?.email}</Text>
                <Text style={{top: "254px", left: "210px", fontSize: "10px", fontFamily: 'Roboto'}}>{user?.displayName}</Text>
                <Text style={{top: "258px", left: "70px", fontSize: "10px", fontFamily: 'Roboto'}}>{user?.dateOfBirth}</Text>
                <Text style={{top: "244px", left: "210px", fontSize: "10px", fontFamily: 'Roboto'}}>{user?.pesel}</Text>
                <Text style={{top: "248px", left: "92px", fontSize: "10px", fontFamily: 'Roboto'}}>ul. {user?.address?.street + "/" + user?.address?.local} {user?.address?.city}</Text>
                <Text style={{top: "257px", left: "162px", fontSize: "10px", fontFamily: 'Roboto'}}>{date}</Text>
                <Text style={{top: "419px", left: "175px", fontSize: "9px", fontFamily: 'Roboto'}}>{user?.docs?.contract?.price ? user?.docs?.contract?.price : "-"}</Text>
                <Text style={{top: "407px", left: "250px", fontSize: "9px", fontFamily: 'Roboto'}}>{user?.docs?.contract?.groups ? user?.docs?.contract?.groups : "-"}</Text>
                {user?.docs?.contract?.type === "obligation" && <Text style={{top: "556px", left: "273px", fontSize: "9px", fontFamily: 'Roboto'}}>{date}</Text>}
            </Page>
            <Page style={styles.body}>
                  {user?.docs?.contract?.type === "obligation" ?
                  <Image
                    style={styles.imageTest}
                    src={process.env.PUBLIC_URL + "/UmowaTurniejowka_2.png"}
                    fixed
                  />
                  :
                  <Image
                    style={styles.imageTest}
                    src={process.env.PUBLIC_URL + "/Umowa2026_2.png"}
                    fixed
                  />
                  }
                {signing && 
                  <Image
                      style={{top: "240px", left: "60px", width: "80px"}}
                      src={signing}
                      fixed
                  />
                }
            </Page>
          </Document>
    </>
    )
}